// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__r3DO1","link":"Footer_link__gh2xK"};